export default "__VITE_ASSET__DQcJZu_5__"